<script lang="ts">
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import { TwistBox, TwistDivider } from '@twist/core';
</script>

<!-- 
  Additional padding is used to make space around dividers defined
  on portable text level to equal to spacers of divideds defined on
  component level.
-->
<TwistBox paddingY={toFluidVarInput(10, 15)}>
  <TwistDivider thickness="1px" margin={0} />
</TwistBox>
